import localization from '../config/localization/Localization';

function isLanguageSupported(languageCode){
    if(languageCode == null){
        return false
    }
    return Object.keys(localization).includes(languageCode)
}

export function getLocalizationLanguageCode(languageCode){
    if(isLanguageSupported(languageCode)){
        return languageCode
    } else {
        return 'default'
    }
}